import { useIsAiFieldCellStreaming } from '../use-is-ai-field-cell-streaming';

import type { AiFieldCellRequestTarget } from './ai-field-cell-request-coordinator';
import { useAiFieldCellRequestState } from './use-ai-field-cell-request-state';

export type UseIsAiFieldCellProcessingOptions = AiFieldCellRequestTarget;

export const useIsAiFieldCellProcessing = ({
  contentId,
  aiFieldType,
  fieldId,
  entryId
}: UseIsAiFieldCellProcessingOptions): boolean => {
  const requestState = useAiFieldCellRequestState({
    contentId,
    aiFieldType,
    fieldId,
    entryId
  });
  const isStreaming = useIsAiFieldCellStreaming({ fieldId, entryId });

  return requestState.status !== 'idle' || isStreaming;
};
